module.exports = __webpack_public_path__ + "static/apple-touch-icon-f465f8b6fd11ef12a9cd54f308798051.png";